
import {Component, Vue, Watch} from "vue-property-decorator";
import {PdaUsercodename, DestinationOrgcodename} from "@/views/components";
import {ScanforAcceptPacketModule} from "@/store/modules/store_scanforacceptpacket";
import {
  queryTimeTypes,
  queryOpFrequency,
  queryCustomerInfo,
} from "@/api/service";
import {LogHelper} from "@/common/LogHelper";
import {playFailSound} from "@/common/voiceTip";
import {ScanSysType} from "@/common/glboalconstant";
import dayjs from "dayjs";
import {SystemConfigModule} from "@/store/modules/store_systemconfig";

@Component({
  name: "Form1",
  components: {
    PdaUsercodename,
    DestinationOrgcodename,
  },
  props: {
    callbackdata: {
      type: Object,
      default: false,
    },
  },
  watch: {
    callbackdata(newone, oldone) {
      if (newone.input_TrueThingCode != this.inputModel.input_TrueThingCode) {
        this.inputModel.input_TrueThingCode = newone.input_TrueThingCode;
      }
      if (newone.input_Length != this.inputModel.input_Length) {
        if (!this.inputModel.checked_InputLength) {
          this.inputModel.input_Length = newone.input_Length;
        }
      }
      if (newone.input_Width != this.inputModel.input_Width) {
        if (!this.inputModel.checked_InputWidth) {
          this.inputModel.input_Width = newone.input_Width;
        }
      }
      if (newone.input_Height != this.inputModel.input_Height) {
        if (!this.inputModel.checked_InputHeight) {
          this.inputModel.input_Height = newone.input_Height;
        }
      }
      if (newone.input_CustomNow != this.inputModel.input_CustomNow) {
        if (!this.inputModel.checked_CustomNow) {
          this.inputModel.input_CustomNow = newone.input_CustomNow;
          this.inputModel.input_Custom = "";
        }
      }
      if (
        newone.input_DestinationOrgNow !=
        this.inputModel.input_DestinationOrgNow
      ) {
        if (!this.inputModel.checked_DestinationOrgNow) {
          this.inputModel.input_DestinationOrgNow =
            newone.input_DestinationOrgNow;
          this.inputModel.input_DestinationOrg = "";
        }
      }
      if (newone.input_WeighWeight != this.inputModel.input_WeighWeight) {
        this.inputModel.input_WeighWeight = newone.input_WeighWeight;
      }
      if (newone.input_PutInWeight != this.inputModel.input_PutInWeight) {
        this.inputModel.input_PutInWeight = newone.input_PutInWeight;
      }
      if (newone.input_VolumeWeight != this.inputModel.input_VolumeWeight) {
        this.inputModel.input_VolumeWeight = newone.input_VolumeWeight;
      }
    },
  },
})
export default class extends Vue {
  public globalConfig: any = {};
  public systemConfig: any = {};
  public loginData: any = {};
  public putInWeightLockShow = false;
  public offsetValue = 0;
  public m_iScanSystem = -1;

  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    this.systemConfig = SystemConfigModule.systemData;
    this.loginData = SystemConfigModule.loginData;
    this.putInWeightLockFlag = false;
    this.m_iScanSystem = this.systemConfig.ModeInfo.Mode_Type;
    if (this.m_iScanSystem == ScanSysType.CrazeScan) {
      this.putInWeightLockShow = true;
      // this.offsetValue = 0;
    } else {
      this.putInWeightLockShow = false;
      // this.offsetValue = 2;
    }

    this.InitQueryTimeTypesFunc();
    this.InitFrequencyFunc();

  }

  @Watch("inputModel", {deep: true})
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }

  @Watch("putInWeightLockFlag", {deep: true})
  onputInWeightLockFlagChanged(val: boolean) {
    this.inputModel.input_PutInWeightDisable = val;
  }

  get putInWeightLockFlag() {
    return ScanforAcceptPacketModule.putInWeightLock;
  }

  set putInWeightLockFlag(state) {
    ScanforAcceptPacketModule.PutInWeightLockChangeState(state);
    // ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
  }

  public clearTimer = null;
  public setTime;

  public PutInWeightLockFlagChage(state) {
    if (state) {
      if (
        parseFloat(this.inputModel.input_PutInWeight.toString()).toString() ==
        "NaN" ||
        parseFloat(this.inputModel.input_PutInWeight.toString()).toString() ==
        "0"
      ) {
        this.$message.error("请先输入重量");
        this.$nextTick(() => {
          this.putInWeightLockFlag = false;
        });
      } else {
        if (parseFloat(this.inputModel.input_PutInWeight.toString()) > 50) {
          this.$message.error("只允许输入最大重量为50KG");
          this.$nextTick(() => {
            this.putInWeightLockFlag = false;
          });
          return;
        } else if (
          parseFloat(this.inputModel.input_PutInWeight.toString()) < 0.01
        ) {
          this.$message.error("只允许输入最小重量为0.01KG");
          this.$nextTick(() => {
            this.putInWeightLockFlag = false;
          });
          return;
        } else {
          let _putinweight = parseFloat(
            this.inputModel.input_PutInWeight.toString()
          ).toString();
          this.$confirm(
            '<strong><i style="color:red;font-size:40px;">' +
            _putinweight +
            "</i>KG ，您是否锁定该重量扫描？</strong>",
            "重量点击锁定确认",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "输入重量已锁定",
              });
              this.setTime = dayjs()
                .add(10, "hour")
                .format("YYYY-MM-DD HH:mm:ss");
              if (this.clearTimer != null) {
                clearInterval(this.clearTimer);
                this.clearTimer = null;
              }
              this.clearTimer = setInterval(() => {
                if (this.setTime == dayjs().format("YYYY-MM-DD HH:mm:ss")) {
                  this.putInWeightLockFlag = false;
                  clearInterval(this.clearTimer);
                  this.clearTimer = null;
                }
              }, 1000);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "输入重量未锁定",
              });
              this.putInWeightLockFlag = false;
            });
        }
      }
    }
  }

  //查询产品时效
  public InitQueryTimeTypesFunc() {
    try {
      let stTimeTypes_Input: any = {};
      let stTimeTypes_ReturnData: any = {};
      stTimeTypes_Input.devMac = this.globalConfig.LocalMac;
      stTimeTypes_Input.devType = "0";
      let body: any = {};
      stTimeTypes_Input.body = body;
      stTimeTypes_Input.body.queryValue = "";
      stTimeTypes_Input.body.queryType = "6";
      stTimeTypes_Input.body.viewType = "0";
      stTimeTypes_Input.body.extend1 = "";
      stTimeTypes_Input.body.extend2 = "";
      stTimeTypes_Input.body.extend3 = "";
      let responseStr = queryTimeTypes(JSON.stringify(stTimeTypes_Input));
      stTimeTypes_ReturnData = JSON.parse(responseStr);
      if (
        stTimeTypes_ReturnData == null ||
        stTimeTypes_ReturnData.respcode != "000"
      ) {
        debugger
        this.options_TakingEffectiveTime = [];
        LogHelper.Error("ScanForAcceptPacket,查询产品时效失败，错误:" + responseStr);
      } else {
        try {
          if (stTimeTypes_ReturnData.data.busiDataArray != null) {
            let TimeTypesList = [];
            for (
              let iIndex = 0;
              iIndex < stTimeTypes_ReturnData.data.busiDataArray.length;
              iIndex++
            ) {
              TimeTypesList.push({
                value: stTimeTypes_ReturnData.data.busiDataArray[iIndex].key,
                label: stTimeTypes_ReturnData.data.busiDataArray[iIndex].value,
              });
            }

            this.options_TakingEffectiveTime = TimeTypesList;
            ScanforAcceptPacketModule.QueryTimeTypesListSet(TimeTypesList);
            if (TimeTypesList.length > 0) {
              for (let index = 0; index < TimeTypesList.length; index++) {
                const element = TimeTypesList[index];
                if (element.label == "72小时件") {
                  this.inputModel.input_TakingEffectiveTime = element.value;
                  break;
                } else {
                  this.inputModel.input_TakingEffectiveTime =
                    TimeTypesList[0].value;
                }
              }
            }
          }
        } catch (ex) {
          LogHelper.Error(
            "ScanForAcceptPacket" + " 设置时效失败! " + ex.toString()
          );
        }
      }
    } catch (error) {
      LogHelper.Error("[错误]:InitQueryTimeTypesFunc:" + error.message);
    }
  }

  // public initQueryTimeTypes(datas) {
  //   this.options_TakingEffectiveTime = datas;
  //   if (datas.length > 0) {
  //     for (let index = 0; index < datas.length; index++) {
  //       const element = datas[index];
  //       if (element.label == "72小时件") {
  //         this.inputModel.input_TakingEffectiveTime = element.value;
  //         break;
  //       } else {
  //         this.inputModel.input_TakingEffectiveTime = datas[0].value;
  //       }
  //     }
  //   }
  // }

  //查询揽收频次
  public InitFrequencyFunc() {
    try {
      let stOpFrequency_Input: any = {};

      stOpFrequency_Input.devMac = this.globalConfig.LocalMac;
      stOpFrequency_Input.devType = "0";
      let body: any = {};
      stOpFrequency_Input.body = body;
      stOpFrequency_Input.body.queryValue = "";
      stOpFrequency_Input.body.queryType = "14";
      stOpFrequency_Input.body.viewType = "0";
      stOpFrequency_Input.body.extend1 = "";
      stOpFrequency_Input.body.extend2 = "";
      stOpFrequency_Input.body.extend3 = "";

      let strOpFrequencyReturnStr =
        this.GetOpFrequencyFunc(stOpFrequency_Input);
      let strOpFrequencyReturn = JSON.parse(strOpFrequencyReturnStr);
      if (
        strOpFrequencyReturn == null ||
        strOpFrequencyReturn.respcode != "000"
      ) {
        LogHelper.Error(
          "ScanForAcceptPacket: InitFrequencyFunc" + strOpFrequencyReturnStr
        );
      } else {
        try {
          if (strOpFrequencyReturn.data.busiDataArray != null) {
            let FrequencyList = [];
            for (
              let iIndex = 0;
              iIndex < strOpFrequencyReturn.data.busiDataArray.length;
              iIndex++
            ) {
              FrequencyList.push({
                value: strOpFrequencyReturn.data.busiDataArray[iIndex].code,
                label: strOpFrequencyReturn.data.busiDataArray[iIndex].name,
              });
            }
            this.options_LineFrequencyNo = FrequencyList;
            if (FrequencyList.length > 0) {
              this.inputModel.input_LineFrequencyNo = FrequencyList[0].value;
            } else {
              this.inputModel.input_LineFrequencyNo = null;
            }
          }
        } catch (ex) {
          LogHelper.Error(
            "ScanForAcceptPacket： InitFrequencyFunc" +
            " crash! " +
            ex.Message
          );
        }
      }
    } catch (error) {
      LogHelper.Error("[错误]:揽收初始化频次异常:" + error.message);
    }
  }

  //查询揽收频次的接口请求
  private GetOpFrequencyFunc(data) {
    let stOpFrequency_Input: any = {};
    stOpFrequency_Input.devMac = this.globalConfig.LocalMac;
    stOpFrequency_Input.devType = "0";
    let body: any = {};
    stOpFrequency_Input.body = body;
    stOpFrequency_Input.body.queryValue = "";
    stOpFrequency_Input.body.queryType = "14";
    stOpFrequency_Input.body.viewType = "0";
    stOpFrequency_Input.body.extend1 = "";
    stOpFrequency_Input.body.extend2 = "";
    stOpFrequency_Input.body.extend3 = "";

    let responseStr = queryOpFrequency(JSON.stringify(stOpFrequency_Input));
    return responseStr;
  }

  // private initFrequency(datas) {
  //   this.options_LineFrequencyNo = datas;
  //   if (datas.length > 0) {
  //     this.inputModel.input_LineFrequencyNo = datas[0].value;
  //   } else {
  //     this.inputModel.input_LineFrequencyNo = null;
  //   }
  // }

  private pdauserdialogshow = false;

  public pdausercodenameFunc(pdauserModel) {
    this.pdauserdialogshow = false;
    if (pdauserModel != null) {
      this.inputModel.input_Person = pdauserModel.userCode;
      this.inputModel.input_PersonNow =
        pdauserModel.userCode + "|" + pdauserModel.userName;
    }
  }

  public findpdausercodename() {
    this.pdauserdialogshow = true;
  }

  private destinationorgdialogshow = false;

  public finddestinationorgcodename() {
    this.destinationorgdialogshow = true;
  }

  public destinationorgcodenameFunc(destinationorgModel) {
    this.destinationorgdialogshow = false;
    if (destinationorgModel != null) {
      this.inputModel.input_DestinationOrg = destinationorgModel.code;
      this.inputModel.input_DestinationOrgNow =
        destinationorgModel.code + "|" + destinationorgModel.name;
    }
  }

  private CustomNowLock() {
    if (this.inputModel.checked_CustomNow == true) {
      this.inputModel.input_CustomDisable = true;
    } else {
      this.inputModel.input_CustomDisable = false;
    }
  }

  private DestinationNowcheckFunc() {
    if (this.inputModel.input_DestinationOrgNow == "") {
      this.errormessage = "当前目的网点为空，锁定无效";
      this.inputModel.checked_DestinationOrgNow = false;
    } else {
      if (this.inputModel.checked_DestinationOrgNow == true) {
        this.$confirm("锁定后目的地为同一个代码，锁定需谨慎！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.inputModel.input_DestinationOrgDisable = true;
          })
          .catch(() => {
            this.inputModel.checked_DestinationOrgNow = false;
          });
      } else {
        this.inputModel.input_DestinationOrgDisable = false;
      }
    }
  }

  private expressContentCodeLock() {
    if (this.inputModel.checked_ExpressContentCode == true) {
      this.inputModel.input_ExpressContentCodeDisable = true;
    } else {
      this.inputModel.input_ExpressContentCodeDisable = false;
    }
  }

  private inputLengthFunc() {
    if (this.inputModel.checked_InputLength == true) {
      this.inputModel.input_LengthDisable = true;
    } else {
      this.inputModel.input_LengthDisable = false;
    }
  }

  private inputLengthNumberFunc(str) {
    try {
      if (isNaN(str)) {
        this.errormessage = "长输入错误，请重新输入";
        this.inputModel.input_Length = "0";
        return;
      } else {
        var number = Number(str);
        this.inputModel.input_Length = String(number);
        this.errormessage = "";
      }
    } catch (error) {
      this.errormessage = "长输入错误，请重新输入";
    }
  }

  private inputWidthFunc() {
    if (this.inputModel.checked_InputWidth == true) {
      this.inputModel.input_WidthDisable = true;
    } else {
      this.inputModel.input_WidthDisable = false;
    }
  }

  private inputWidthNumberFunc(str) {
    try {
      if (isNaN(str)) {
        this.errormessage = "宽输入错误，请重新输入";
        this.inputModel.input_Width = "0";
        return;
      } else {
        var number = Number(str);
        this.inputModel.input_Width = String(number);
        this.errormessage = "";
      }
    } catch (error) {
      this.errormessage = "宽输入错误，请重新输入";
    }
  }

  private inputHeightFunc() {
    if (this.inputModel.checked_InputHeight == true) {
      this.inputModel.input_HeightDisable = true;
    } else {
      this.inputModel.input_HeightDisable = false;
    }
  }

  private inputHeightNumberFunc(str) {
    try {
      if (isNaN(str)) {
        this.errormessage = "高输入错误，请重新输入";
        this.inputModel.input_Height = "0";
        return;
      } else {
        var number = Number(str);
        this.inputModel.input_Height = String(number);
        this.errormessage = "";
      }
    } catch (error) {
      this.errormessage = "高输入错误，请重新输入";
    }
  }

  private putinweightnumberfunc(str) {
    try {
      if (isNaN(str)) {
        this.errormessage = "输入重数字输入错误，请重新输入";
        this.inputModel.input_PutInWeight = String(0);
        return;
      } else {
        var number = Number(str);
        this.inputModel.input_PutInWeight = String(number);
        this.errormessage = "";
      }
    } catch (error) {
      this.errormessage = "输入重数字输入错误，请重新输入";
    }
  }

  public clearsendcustomer() {
    this.inputModel.input_CustomNow = "";
  }

  //选择寄件用户
  public checksendcustomernum(): void {
    if (this.inputModel.checked_CustomNow == true) {
      //this.messageboxShow("warning", "客户已被锁定，请先解锁");
    } else {
      // var sendcustomernum = this.inputModel.input_Custom;
      try {
        if (this.inputModel.input_Custom.length == 0) {
          return;
        }
        let stCodeCheckInput: any = {};
        let stReturnData: any = {};
        stCodeCheckInput.devMac = this.globalConfig.LocalMac;
        stCodeCheckInput.devType = "0";
        let strTempCode = this.inputModel.input_Custom;
        strTempCode = strTempCode.toUpperCase();
        let body: any = {};
        stCodeCheckInput.body = body;
        stCodeCheckInput.body.queryValue = strTempCode;
        stCodeCheckInput.body.queryType = "3";
        stCodeCheckInput.body.viewType = "1";
        stCodeCheckInput.body.extend1 = "";
        stCodeCheckInput.body.extend2 = "";
        stCodeCheckInput.body.extend3 = "";
        let strReturnStr = queryCustomerInfo(JSON.stringify(stCodeCheckInput));
        let strReturn = JSON.parse(strReturnStr);

        if (strReturn == null || strReturn.respcode != "000") {
          try {
            playFailSound();
          } catch (Exception) {
            LogHelper.Error("揽收选择客户失败:失败提示音不存在" + Exception.toString());
          }

          if (strReturn.respMessage == null) {
            LogHelper.Error("揽收选择客户失败:" + "服务器掉线");
          } else {
            LogHelper.Error("揽收选择客户失败:" + strReturn.respMessage);
          }
        } else {
          let name = "";
          if (
            strReturn.data.busiData.customerId == null ||
            strReturn.data.busiData.customerId == undefined ||
            strReturn.data.busiData.customerName == null ||
            strReturn.data.busiData.customerName == undefined
          ) {
            name = "|";
          } else {
            name =
              strReturn.data.busiData.customerId +
              "|" +
              strReturn.data.busiData.customerName;
            //tbx_SendCustomerName.Text = stReturnData.data.busiData.customerId + "|" +
            //stReturnData.data.busiData.customerName;
          }
          this.inputModel.input_CustomNow = name;
        }
      } catch (error) {
        LogHelper.Error("[错误]:" + "C#选择寄件客户出现异常," + error.message);
      }
    }
  }

  //选择寄件客户回调
  public setsendcustomercallback(name): void {
    this.inputModel.input_CustomNow = name;
  }

  //下一网点界面更新判定
  public options_NextOrg = [];

  private getNextOrgCallback(datas) {
    this.inputModel.input_NextOrgNow =
      datas.nextOrgCode + "|" + datas.nextOrgName;
    var jsonobj = JSON.parse(datas.result);
    if (jsonobj.data.busiDataArray != null) {
      this.options_NextOrg = [];
      jsonobj.data.busiDataArray.forEach((element) => {
        this.options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode,
        });
      });
      this.inputModel.input_NextOrg = this.options_NextOrg[0].label;
    }
  }

  //输入重界面方法
  private putinweightFunc() {
    if (this.inputModel.checked_PutInWeight == true) {
      this.inputModel.input_PutInWeightDisable = true;
    } else {
      this.inputModel.input_PutInWeightDisable = false;
    }
  }

  //初始化用户
  public options_Person = [];

  private initpdauser(datas): void {
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var allpersons = jsonobj.data.busiData.records;
      this.options_Person = [];
      allpersons.forEach((element) => {
        this.options_Person.push({
          value: element.userName,
          label: element.userCode,
        });
      });
    } else {
      LogHelper.Error("[错误]:初始化获取用户失败");
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }

  //初始化组织
  private list_DestinationOrg = [];

  private initorgcode(datas): void {
    this.list_DestinationOrg = [];
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var allorgcodes = jsonobj.data.busiData.records;
      allorgcodes.forEach((element) => {
        this.list_DestinationOrg.push({
          value: element.name,
          label: element.code,
        });
      });
    } else {
      LogHelper.Error("[错误]:" + datas);
    }
  }

  //初始化线路
  private initlinedata(datas): void {
    this.list_LineData = [];
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var alllinedata = jsonobj.data.busiData.records;
      alllinedata.forEach((element) => {
        this.list_LineData.push({
          value: element.transType + "|" + element.lineName,
          label: element.lineNo,
        });
      });
    } else {
      LogHelper.Error("[错误]:" + datas);
    }
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type,
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }

  //收派员界面更新判定
  private choosePerson(_value): void {
    if (this.inputModel.checked_PersonNow == true) {
      this.messageboxShow("warning", "已锁定，如需修改，请先解除锁定！");
    } else {
      var nub = this.options_Person.find((per) => per.value == _value);
      this.inputModel.input_PersonNow = nub.label + "|" + nub.value;
    }
  }

  //组织界面更新判定
  private chooseOrgCode(_value): void {
    if (this.inputModel.checked_DestinationOrgNow == true) {
      this.messageboxShow("warning", "已锁定，如需修改，请先解除锁定！");
    } else {
      var nub = this.list_DestinationOrg.find((per) => per.value == _value);
      this.inputModel.input_DestinationOrgNow = nub.label + "|" + nub.value;
    }
  }

  //表格选中当前行
  public setCurrent(row) {
    this.$refs.singleTable[0].setCurrentRow();
  }

  public keypress(e) {
    e.target.select();
  }

  public loading_DestinationOrg = false;
  public loading_LineData = false;
  public list_LineData = [];
  public options = [];
  private form = null;
  private errormessage = "";
  public options_TakingEffectiveTime = [
    {
      value: "1",
      label: "72小时件",
    },
    {
      value: "2",
      label: "隔日达",
    },
  ];
  public options_LineFrequencyNo = [];
  public options_ExpressContentCode = [
    {
      value: "1",
      label: "包裹",
    },
    {
      value: "2",
      label: "文件",
    },
  ];
  private inputModel: inputDataModel_AcceptPacket = {
    checked_OverWeightPromot: false,
    checked_NeedWeight: false,
    input_TakingEffectiveTime: "",
    input_LineFrequencyNo: "",
    input_ExpressContentCode: "包裹",
    input_ExpressContentCodeDisable: false,
    checked_ExpressContentCode: false,
    input_Length: "0",
    input_LengthDisable: false,
    checked_InputLength: false,
    input_Width: "0",
    input_WidthDisable: false,
    checked_InputWidth: false,
    input_Height: "0",
    input_HeightDisable: false,
    checked_InputHeight: false,
    input_ScanCode: "",
    input_CarLabel: "",
    input_TrueThingCode: "",
    input_PanelLine: "",
    input_PanelLineNow: "",
    input_NextOrg: "",
    input_NextOrgNow: "",
    input_DestinationOrg: "",
    input_DestinationOrgNow: "",
    input_Person: "",
    input_PersonNow: "",
    input_Custom: "",
    input_CustomNow: "",
    input_WeighWeight: "0.0",
    input_PutInWeight: "0.0",
    input_VolumeWeight: "0.0",
    input_CustomDisable: false,
    input_DestinationOrgDisable: false,
    checked_DestinationOrgNow: false,
    checked_PersonNow: false,
    checked_CustomNow: false,
    checked_PutInWeight: false,
    checked_GetOrderDestnationOrg: true,
    checked_Voice: false,
    input_PutInWeightDisable: false,
  };
}
